"use client";
import { createGlobalStyle } from "styled-components";
import { globalTextStyles } from "../../foundation/typography/index.js";
const RegisterVolkswagenTheme = createGlobalStyle`
    .theme-volkswagen {
  --moller-opacity-on-focus: 0.16;
  --moller-opacity-on-pressed: 0.16;
  --moller-opacity-on-hover: 0.08;
  --moller-opacity-percentage-16: 0.16;
  --moller-opacity-percentage-8: 0.08;
  --moller-border-radius-full: 999px;
  --moller-border-radius-xx-large: 16px;
  --moller-border-radius-x-large: 12px;
  --moller-border-radius-large: 8px;
  --moller-border-radius-medium: 4px;
  --moller-border-radius-small: 2px;
  --moller-border-radius-none: 0px;
  --moller-keycolor-interactive: #7F328A;
  --moller-keycolor-info: #4CC7F4;
  --moller-keycolor-success: #029640;
  --moller-keycolor-warning: #EE7203;
  --moller-keycolor-error: #E4002C;
  --moller-keycolor-neutral-variant: #D4DEE9;
  --moller-keycolor-neutral: #6A767D;
  --moller-keycolor-tertiary-variant: #737D86;
  --moller-keycolor-tertiary: #00B0F0;
  --moller-keycolor-secondary: #00B0F0;
  --moller-keycolor-primary: #001E50;
  --moller-elevation-high: 0px 0px 1px 0px #0000003d, 0px 2px 16px 0px #00000014, 0px 8px 48px 0px #0000000f;
  --moller-elevation-medium: 0px 0px 1px 0px #0000003d, 0px 4px 8px 0px #0000000a, 0px 8px 24px 0px #0000000f;
  --moller-elevation-low: 0px 0px 1px 0px #0000003d, 0px 1px 4px 0px #0000000a, 0px 4px 8px 0px #0000000f;
  --moller-elevation-none: 0px 0px 0px 0px #00000000;
  --moller-radius-checkbox: 0px;
  --moller-radius-feedback: 12px;
  --moller-radius-overlay: 12px;
  --moller-radius-picker: 12px;
  --moller-radius-input: 12px;
  --moller-radius-card: 4px;
  --moller-radius-button: 12px;
  --moller-stroke-large: 4px;
  --moller-stroke-medium: 2px;
  --moller-stroke-small: 1px;
  --moller-stroke-x-small: 0.5px;
  --moller-type-compact-notice-text-case: uppercase;
  --moller-type-compact-notice-text-decoration: none;
  --moller-type-compact-notice-paragraph-spacing: 0.75rem;
  --moller-type-compact-notice-letter-spacing: 0;
  --moller-type-compact-notice-font-size: 0.75rem;
  --moller-type-compact-notice-line-height: 1.4;
  --moller-type-compact-notice-font-weight: 500;
  --moller-type-compact-notice-font-family: VW Text;
  --moller-type-compact-label-text-case: none;
  --moller-type-compact-label-text-decoration: none;
  --moller-type-compact-label-paragraph-spacing: 0.625rem;
  --moller-type-compact-label-letter-spacing: 0;
  --moller-type-compact-label-font-size: 0.625rem;
  --moller-type-compact-label-line-height: 1.4;
  --moller-type-compact-label-font-weight: 400;
  --moller-type-compact-label-font-family: VW Text;
  --moller-type-compact-action-text-case: none;
  --moller-type-compact-action-text-decoration: none;
  --moller-type-compact-action-paragraph-spacing: 0.875rem;
  --moller-type-compact-action-letter-spacing: 0;
  --moller-type-compact-action-font-size: 0.875rem;
  --moller-type-compact-action-line-height: 1.4;
  --moller-type-compact-action-font-weight: 500;
  --moller-type-compact-action-font-family: VW Text;
  --moller-type-small-description-text-case: none;
  --moller-type-small-description-text-decoration: none;
  --moller-type-small-description-paragraph-spacing: 0.75rem;
  --moller-type-small-description-letter-spacing: 0;
  --moller-type-small-description-font-size: 0.75rem;
  --moller-type-small-description-line-height: 1.4;
  --moller-type-small-description-font-weight: 400;
  --moller-type-small-description-font-family: VW Head;
  --moller-type-small-link-text-case: none;
  --moller-type-small-link-text-decoration: underline;
  --moller-type-small-link-paragraph-spacing: 1rem;
  --moller-type-small-link-letter-spacing: 0;
  --moller-type-small-link-font-size: 1rem;
  --moller-type-small-link-line-height: 1.4;
  --moller-type-small-link-font-weight: 400;
  --moller-type-small-link-font-family: VW Head;
  --moller-type-small-body-text-case: none;
  --moller-type-small-body-text-decoration: none;
  --moller-type-small-body-paragraph-spacing: 1rem;
  --moller-type-small-body-letter-spacing: 0;
  --moller-type-small-body-font-size: 1rem;
  --moller-type-small-body-line-height: 1.4;
  --moller-type-small-body-font-weight: 400;
  --moller-type-small-body-font-family: VW Head;
  --moller-type-small-lead-text-case: none;
  --moller-type-small-lead-text-decoration: none;
  --moller-type-small-lead-paragraph-spacing: 1.25rem;
  --moller-type-small-lead-letter-spacing: 0;
  --moller-type-small-lead-font-size: 1.25rem;
  --moller-type-small-lead-line-height: 1.4;
  --moller-type-small-lead-font-weight: 400;
  --moller-type-small-lead-font-family: VW Text;
  --moller-type-small-overline-text-case: uppercase;
  --moller-type-small-overline-text-decoration: none;
  --moller-type-small-overline-paragraph-spacing: 1.125rem;
  --moller-type-small-overline-letter-spacing: 0;
  --moller-type-small-overline-font-size: 0.75rem;
  --moller-type-small-overline-line-height: 1.4;
  --moller-type-small-overline-font-weight: 500;
  --moller-type-small-overline-font-family: VW Head;
  --moller-type-small-subtitle-text-case: none;
  --moller-type-small-subtitle-text-decoration: none;
  --moller-type-small-subtitle-paragraph-spacing: 1.5rem;
  --moller-type-small-subtitle-letter-spacing: 0;
  --moller-type-small-subtitle-font-size: 1rem;
  --moller-type-small-subtitle-line-height: 1.4;
  --moller-type-small-subtitle-font-weight: 500;
  --moller-type-small-subtitle-font-family: VW Head;
  --moller-type-small-headline-text-case: none;
  --moller-type-small-headline-text-decoration: none;
  --moller-type-small-headline-paragraph-spacing: 2.25rem;
  --moller-type-small-headline-letter-spacing: 0;
  --moller-type-small-headline-font-size: 1.5rem;
  --moller-type-small-headline-line-height: 1.4;
  --moller-type-small-headline-font-weight: 500;
  --moller-type-small-headline-font-family: VW Head;
  --moller-type-small-display-text-case: none;
  --moller-type-small-display-text-decoration: none;
  --moller-type-small-display-paragraph-spacing: 3rem;
  --moller-type-small-display-letter-spacing: 0;
  --moller-type-small-display-font-size: 2rem;
  --moller-type-small-display-line-height: 1.4;
  --moller-type-small-display-font-weight: 500;
  --moller-type-small-display-font-family: VW Head;
  --moller-type-medium-description-text-case: none;
  --moller-type-medium-description-text-decoration: none;
  --moller-type-medium-description-paragraph-spacing: 0.75rem;
  --moller-type-medium-description-letter-spacing: 0;
  --moller-type-medium-description-font-size: 0.75rem;
  --moller-type-medium-description-line-height: 1.4;
  --moller-type-medium-description-font-weight: 400;
  --moller-type-medium-description-font-family: VW Text;
  --moller-type-medium-link-text-case: none;
  --moller-type-medium-link-text-decoration: underline;
  --moller-type-medium-link-paragraph-spacing: 1rem;
  --moller-type-medium-link-letter-spacing: 0;
  --moller-type-medium-link-font-size: 1rem;
  --moller-type-medium-link-line-height: 1.4;
  --moller-type-medium-link-font-weight: 400;
  --moller-type-medium-link-font-family: VW Text;
  --moller-type-medium-body-text-case: none;
  --moller-type-medium-body-text-decoration: none;
  --moller-type-medium-body-paragraph-spacing: 1rem;
  --moller-type-medium-body-letter-spacing: 0;
  --moller-type-medium-body-font-size: 1rem;
  --moller-type-medium-body-line-height: 1.4;
  --moller-type-medium-body-font-weight: 400;
  --moller-type-medium-body-font-family: VW Text;
  --moller-type-medium-lead-text-case: none;
  --moller-type-medium-lead-text-decoration: none;
  --moller-type-medium-lead-paragraph-spacing: 1.5rem;
  --moller-type-medium-lead-letter-spacing: 0;
  --moller-type-medium-lead-font-size: 1.5rem;
  --moller-type-medium-lead-line-height: 1.4;
  --moller-type-medium-lead-font-weight: 400;
  --moller-type-medium-lead-font-family: VW Text;
  --moller-type-medium-overline-text-case: uppercase;
  --moller-type-medium-overline-text-decoration: none;
  --moller-type-medium-overline-paragraph-spacing: 1.5rem;
  --moller-type-medium-overline-letter-spacing: 0;
  --moller-type-medium-overline-font-size: 1rem;
  --moller-type-medium-overline-line-height: 1.4;
  --moller-type-medium-overline-font-weight: 500;
  --moller-type-medium-overline-font-family: VW Head;
  --moller-type-medium-subtitle-text-case: none;
  --moller-type-medium-subtitle-text-decoration: none;
  --moller-type-medium-subtitle-paragraph-spacing: 1.875rem;
  --moller-type-medium-subtitle-letter-spacing: 0;
  --moller-type-medium-subtitle-font-size: 1.25rem;
  --moller-type-medium-subtitle-line-height: 1.4;
  --moller-type-medium-subtitle-font-weight: 500;
  --moller-type-medium-subtitle-font-family: VW Head;
  --moller-type-medium-headline-text-case: none;
  --moller-type-medium-headline-text-decoration: none;
  --moller-type-medium-headline-paragraph-spacing: 2.625rem;
  --moller-type-medium-headline-letter-spacing: 0;
  --moller-type-medium-headline-font-size: 1.75rem;
  --moller-type-medium-headline-line-height: 1.4;
  --moller-type-medium-headline-font-weight: 500;
  --moller-type-medium-headline-font-family: VW Head;
  --moller-type-medium-display-text-case: none;
  --moller-type-medium-display-text-decoration: none;
  --moller-type-medium-display-paragraph-spacing: 4.5rem;
  --moller-type-medium-display-letter-spacing: 0;
  --moller-type-medium-display-font-size: 3rem;
  --moller-type-medium-display-line-height: 1.4;
  --moller-type-medium-display-font-weight: 500;
  --moller-type-medium-display-font-family: VW Head;
  --moller-type-default-notice-text-case: uppercase;
  --moller-type-default-notice-text-decoration: none;
  --moller-type-default-notice-paragraph-spacing: 1rem;
  --moller-type-default-notice-letter-spacing: 0;
  --moller-type-default-notice-font-size: 1rem;
  --moller-type-default-notice-line-height: 1.4;
  --moller-type-default-notice-font-weight: 500;
  --moller-type-default-notice-font-family: VW Text;
  --moller-type-default-label-text-case: none;
  --moller-type-default-label-text-decoration: none;
  --moller-type-default-label-paragraph-spacing: 0.75rem;
  --moller-type-default-label-letter-spacing: 0;
  --moller-type-default-label-font-size: 0.75rem;
  --moller-type-default-label-line-height: 1.4;
  --moller-type-default-label-font-weight: 400;
  --moller-type-default-label-font-family: VW Text;
  --moller-type-default-action-text-case: none;
  --moller-type-default-action-text-decoration: none;
  --moller-type-default-action-paragraph-spacing: 1rem;
  --moller-type-default-action-letter-spacing: 0;
  --moller-type-default-action-font-size: 1rem;
  --moller-type-default-action-line-height: 1.4;
  --moller-type-default-action-font-weight: 500;
  --moller-type-default-action-font-family: VW Text;
  --moller-type-large-description-text-case: none;
  --moller-type-large-description-text-decoration: none;
  --moller-type-large-description-paragraph-spacing: 0.875rem;
  --moller-type-large-description-letter-spacing: 0;
  --moller-type-large-description-font-size: 0.875rem;
  --moller-type-large-description-line-height: 1.4;
  --moller-type-large-description-font-weight: 400;
  --moller-type-large-description-font-family: VW Text;
  --moller-type-large-link-text-case: none;
  --moller-type-large-link-text-decoration: underline;
  --moller-type-large-link-paragraph-spacing: 1rem;
  --moller-type-large-link-letter-spacing: 0;
  --moller-type-large-link-font-size: 1rem;
  --moller-type-large-link-line-height: 1.4;
  --moller-type-large-link-font-weight: 400;
  --moller-type-large-link-font-family: VW Text;
  --moller-type-large-body-text-case: none;
  --moller-type-large-body-text-decoration: none;
  --moller-type-large-body-paragraph-spacing: 1rem;
  --moller-type-large-body-letter-spacing: 0;
  --moller-type-large-body-font-size: 1rem;
  --moller-type-large-body-line-height: 1.4;
  --moller-type-large-body-font-weight: 400;
  --moller-type-large-body-font-family: VW Text;
  --moller-type-large-lead-text-case: none;
  --moller-type-large-lead-text-decoration: none;
  --moller-type-large-lead-paragraph-spacing: 1.75rem;
  --moller-type-large-lead-letter-spacing: 0;
  --moller-type-large-lead-font-size: 1.75rem;
  --moller-type-large-lead-line-height: 1.4;
  --moller-type-large-lead-font-weight: 400;
  --moller-type-large-lead-font-family: VW Text;
  --moller-type-large-overline-text-case: uppercase;
  --moller-type-large-overline-text-decoration: none;
  --moller-type-large-overline-paragraph-spacing: 1.5rem;
  --moller-type-large-overline-letter-spacing: 0;
  --moller-type-large-overline-font-size: 1rem;
  --moller-type-large-overline-line-height: 1.4;
  --moller-type-large-overline-font-weight: 500;
  --moller-type-large-overline-font-family: VW Head;
  --moller-type-large-subtitle-text-case: none;
  --moller-type-large-subtitle-text-decoration: none;
  --moller-type-large-subtitle-paragraph-spacing: 2.25rem;
  --moller-type-large-subtitle-letter-spacing: 0;
  --moller-type-large-subtitle-font-size: 1.5rem;
  --moller-type-large-subtitle-line-height: 1.4;
  --moller-type-large-subtitle-font-weight: 500;
  --moller-type-large-subtitle-font-family: VW Head;
  --moller-type-large-headline-text-case: none;
  --moller-type-large-headline-text-decoration: none;
  --moller-type-large-headline-paragraph-spacing: 3rem;
  --moller-type-large-headline-letter-spacing: 0;
  --moller-type-large-headline-font-size: 2rem;
  --moller-type-large-headline-line-height: 1.4;
  --moller-type-large-headline-font-weight: 500;
  --moller-type-large-headline-font-family: VW Head;
  --moller-type-large-display-text-case: none;
  --moller-type-large-display-text-decoration: none;
  --moller-type-large-display-paragraph-spacing: 5.25rem;
  --moller-type-large-display-letter-spacing: 0;
  --moller-type-large-display-font-size: 3.5rem;
  --moller-type-large-display-line-height: 1.4;
  --moller-type-large-display-font-weight: 500;
  --moller-type-large-display-font-family: VW Head;
  --moller-typeface-line-height: 1.4;
  --moller-typeface-brand-display: VW Head;
  --moller-typeface-text-decoration-strikethrough: line-through;
  --moller-typeface-text-decoration-line: underline;
  --moller-typeface-text-decoration-none: none;
  --moller-typeface-text-case-lowercase: lowercase;
  --moller-typeface-text-case-uppercase: uppercase;
  --moller-typeface-text-case-none: none;
  --moller-typeface-letter-spacing-none: 0;
  --moller-typeface-size-4xl: 3.5rem;
  --moller-typeface-size-3xl: 3rem;
  --moller-typeface-size-xxl: 2rem;
  --moller-typeface-size-xl: 1.75rem;
  --moller-typeface-size-l: 1.5rem;
  --moller-typeface-size-m: 1.25rem;
  --moller-typeface-size-base: 1rem;
  --moller-typeface-size-s: 0.875rem;
  --moller-typeface-size-xs: 0.75rem;
  --moller-typeface-size-xxs: 0.625rem;
  --moller-typeface-weight-bold: 500;
  --moller-typeface-weight-regular: 400;
  --moller-typeface-brand: VW Text;
  --moller-color-highlight: #f4dcf2;
  --moller-color-on-info-container: #005661;
  --moller-color-info-container: #dbf3ff;
  --moller-color-on-info: #ffffff;
  --moller-color-info: #4cc7f4;
  --moller-color-on-success-container: #005c19;
  --moller-color-success-container: #dbf9ea;
  --moller-color-on-success: #ffffff;
  --moller-color-success: #029640;
  --moller-color-on-warning-container: #944700;
  --moller-color-warning-container: #fff7db;
  --moller-color-on-warning: #000000;
  --moller-color-warning: #ee7203;
  --moller-color-on-error-container: #7d0000;
  --moller-color-error-container: #ffdbdb;
  --moller-color-on-error: #ffffff;
  --moller-color-error: #e4002c;
  --moller-color-disabled-variant: #ffffff;
  --moller-color-disabled: #f3f5f8;
  --moller-color-on-surface: #000000;
  --moller-color-surface: #ffffff;
  --moller-color-on-inverse-background: #ffffff;
  --moller-color-inverse-background: #000000;
  --moller-color-on-background: #000000;
  --moller-color-background: #ffffff;
  --moller-color-on-tertiary-variant: #000000;
  --moller-color-tertiary-variant: #737d86;
  --moller-color-on-tertiary-container: #00252b;
  --moller-color-tertiary-container: #b4e0ff;
  --moller-color-on-tertiary: #000000;
  --moller-color-tertiary: #00b0f0;
  --moller-color-on-secondary-container: #00252b;
  --moller-color-on-secondary: #000000;
  --moller-color-primary-container: #b6b6d5;
  --moller-color-on-primary: #ffffff;
  --moller-color-primary: #001e50;
  --moller-color-outline: #c2cacf;
  --moller-color-on-disabled-variant: #35383a;
  --moller-color-on-loader: #3c484d;
  --moller-color-loader: #c2cacf;
  --moller-color-interactive: #721d7d;
  --moller-color-on-surface-variant: #000000;
  --moller-color-surface-variant: #f3f5f8;
  --moller-color-on-disabled: #324046;
  --moller-color-secondary-container: #b4e0ff;
  --moller-color-secondary: #ffffff;
  --moller-color-on-primary-container: #000001;
  --moller-palette-white: #ffffff;
  --moller-palette-black: #000000;
  --moller-palette-tertiary-variant-95: #EAECEF;
  --moller-palette-tertiary-variant-90: #D5D8DE;
  --moller-palette-tertiary-variant-80: #C1C6CE;
  --moller-palette-tertiary-variant-70: #ADB3BC;
  --moller-palette-tertiary-variant-60: #99A1AB;
  --moller-palette-tertiary-variant-50: #868F98;
  --moller-palette-tertiary-variant-40: #737D86;
  --moller-palette-tertiary-variant-30: #4B545C;
  --moller-palette-tertiary-variant-20: #252A30;
  --moller-palette-tertiary-variant-10: #13161A;
  --moller-palette-tertiary-95: #D8EDFF;
  --moller-palette-tertiary-90: #B4E0FF;
  --moller-palette-tertiary-80: #90D5FF;
  --moller-palette-tertiary-70: #6CCCFF;
  --moller-palette-tertiary-60: #48C3FF;
  --moller-palette-tertiary-50: #24BAFF;
  --moller-palette-tertiary-40: #00B0F0;
  --moller-palette-tertiary-30: #0080AB;
  --moller-palette-tertiary-20: #004657;
  --moller-palette-tertiary-10: #00252B;
  --moller-palette-interactive-95: #F4DCF2;
  --moller-palette-interactive-90: #E7BBE5;
  --moller-palette-interactive-80: #D89CD7;
  --moller-palette-interactive-70: #C57FC7;
  --moller-palette-interactive-60: #B064B4;
  --moller-palette-interactive-50: #984AA0;
  --moller-palette-interactive-40: #7F328A;
  --moller-palette-interactive-30: #721D7D;
  --moller-palette-interactive-20: #610D6B;
  --moller-palette-interactive-10: #4C0354;
  --moller-palette-info-95: #DBF3FF;
  --moller-palette-info-90: #BBE9FF;
  --moller-palette-info-80: #9EE2FF;
  --moller-palette-info-70: #84DBFF;
  --moller-palette-info-60: #6ED5FF;
  --moller-palette-info-50: #5BCEFF;
  --moller-palette-info-40: #4CC7F4;
  --moller-palette-info-30: #26A6CA;
  --moller-palette-info-20: #0C8096;
  --moller-palette-info-10: #005661;
  --moller-palette-success-95: #DBF9EA;
  --moller-palette-success-90: #B6F0D2;
  --moller-palette-success-80: #92E4B8;
  --moller-palette-success-70: #6DD59B;
  --moller-palette-success-60: #49C37D;
  --moller-palette-success-50: #24AE5F;
  --moller-palette-success-40: #029640;
  --moller-palette-success-30: #008C32;
  --moller-palette-success-20: #007925;
  --moller-palette-success-10: #005C19;
  --moller-palette-warning-95: #FFF7DB;
  --moller-palette-warning-90: #FFE9B6;
  --moller-palette-warning-80: #FFD692;
  --moller-palette-warning-70: #FFC06D;
  --moller-palette-warning-60: #FFA749;
  --moller-palette-warning-50: #FF8D24;
  --moller-palette-warning-40: #EE7203;
  --moller-palette-warning-30: #DB6300;
  --moller-palette-warning-20: #B85500;
  --moller-palette-warning-10: #944700;
  --moller-palette-error-95: #FFDBDB;
  --moller-palette-error-90: #FFB6B6;
  --moller-palette-error-80: #FF9292;
  --moller-palette-error-70: #FF6D6D;
  --moller-palette-error-60: #FF494C;
  --moller-palette-error-50: #F6243A;
  --moller-palette-error-40: #E4002C;
  --moller-palette-error-30: #D4000E;
  --moller-palette-error-20: #A80000;
  --moller-palette-error-10: #7D0000;
  --moller-palette-neutral-variant-95: #F8FAFD;
  --moller-palette-neutral-variant-90: #F1F6FB;
  --moller-palette-neutral-variant-80: #EAF1F8;
  --moller-palette-neutral-variant-70: #E4ECF5;
  --moller-palette-neutral-variant-60: #DEE7F1;
  --moller-palette-neutral-variant-50: #D9E3ED;
  --moller-palette-neutral-variant-40: #D4DEE9;
  --moller-palette-neutral-variant-30: #9FA7AF;
  --moller-palette-neutral-variant-20: #6A6F75;
  --moller-palette-neutral-variant-10: #35383A;
  --moller-palette-neutral-95: #F3F5F8;
  --moller-palette-neutral-90: #E9EDF1;
  --moller-palette-neutral-80: #DFE4E8;
  --moller-palette-neutral-70: #C2CACF;
  --moller-palette-neutral-60: #96A3A8;
  --moller-palette-neutral-50: #6A767D;
  --moller-palette-neutral-40: #3C484D;
  --moller-palette-neutral-30: #324046;
  --moller-palette-neutral-20: #29383F;
  --moller-palette-neutral-10: #213037;
  --moller-palette-secondary-95: #D8EDFF;
  --moller-palette-secondary-90: #B4E0FF;
  --moller-palette-secondary-80: #90D5FF;
  --moller-palette-secondary-70: #6CCCFF;
  --moller-palette-secondary-60: #48C3FF;
  --moller-palette-secondary-50: #24BAFF;
  --moller-palette-secondary-40: #00B0F0;
  --moller-palette-secondary-30: #0080AB;
  --moller-palette-secondary-20: #004657;
  --moller-palette-secondary-10: #00252B;
  --moller-palette-primary-95: #DBDBEB;
  --moller-palette-primary-90: #B6B6D5;
  --moller-palette-primary-80: #9295BE;
  --moller-palette-primary-70: #6D75A5;
  --moller-palette-primary-60: #49578A;
  --moller-palette-primary-50: #243A6E;
  --moller-palette-primary-40: #001E50;
  --moller-palette-primary-30: #00113F;
  --moller-palette-primary-20: #000724;
  --moller-palette-primary-10: #000001;
  --moller-size-4xl: 64px;
  --moller-size-3xl: 48px;
  --moller-size-xxl: 40px;
  --moller-size-xl: 32px;
  --moller-size-l: 24px;
  --moller-size-m: 20px;
  --moller-size-s: 16px;
  --moller-size-xs: 12px;
  --moller-size-xxs: 8px;
  --moller-size-base: 4px;
  --moller-spacing-3xl: 48px;
  --moller-spacing-xxl: 40px;
  --moller-spacing-xl: 32px;
  --moller-spacing-l: 24px;
  --moller-spacing-m: 20px;
  --moller-spacing-s: 16px;
  --moller-spacing-xs: 12px;
  --moller-spacing-xxs: 8px;
  --moller-spacing-base: 4px;
  --moller-spacing-none: 0px;
  ${globalTextStyles}
    }
`;
export {
  RegisterVolkswagenTheme
};
